import {
  OrderConditionFreightOption,
  OrderConditionSavedFreight,
} from './orderConditionFreightField.types';

export const isQuotedFreight = ({ quoteId }: OrderConditionSavedFreight) => Boolean(quoteId);

export const isSavedQuoteOption = (
  option: OrderConditionFreightOption,
  freight: OrderConditionSavedFreight,
) =>
  isQuotedFreight(freight) &&
  option.quoteId === freight.quoteId &&
  option.methodName === freight.shippingMethod &&
  option.companyName === (freight.shippingCompanyName ?? undefined);

const FREIGHT_OPTION_SUPPORT_SEPARATOR = ' · ';

export const getFreightOptionSupportText = ({
  companyName,
  methodName,
  estimateLabel,
}: Pick<OrderConditionFreightOption, 'companyName' | 'methodName' | 'estimateLabel'>) =>
  [companyName && methodName, estimateLabel]
    .filter(Boolean)
    .join(FREIGHT_OPTION_SUPPORT_SEPARATOR) || undefined;
